import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Navigation } from 'app/core/navigation/navigation.types';
import {
  filter,
  map,
  Observable,
  ReplaySubject,
  switchMap,
  take,
  tap,
} from 'rxjs';
import { UserService } from '../user/user.service';
import { UserRoles } from 'app/constants/roles.constants';
import { FuseNavigationItem } from '@fuse/components/navigation';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private _httpClient = inject(HttpClient);
  private _navigation: ReplaySubject<Navigation> =
    new ReplaySubject<Navigation>(1);
  protected userService = inject(UserService);

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Getter for navigation
   */
  get navigation$(): Observable<Navigation> {
    return this._navigation.asObservable();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Get all navigation data
   */
  get(): Observable<Navigation> {
    return this._httpClient.get<Navigation>('api/common/navigation').pipe(
      switchMap((navigation) =>
        this.userService.user$.pipe(
          filter(Boolean),
          take(1),
          map((user) => {
            // If the user is not an admin...
            Object.keys(navigation).forEach((key) => {
              navigation[key] = this.checkVisibilityByRoles(
                navigation[key],
                user.role
              );
            });
            return navigation;
          })
        )
      ),
      tap((navigation) => {
        this._navigation.next(navigation);
      })
    );
  }

  protected checkVisibilityByRoles(
    items: FuseNavigationItem[],
    userRole: string
  ) {
    return items.filter((item) => {
      if (item.children) {
        item.children = this.checkVisibilityByRoles(item.children, userRole);
      }
      return (
        !item.visibleOnlyTo ||
        !item.visibleOnlyTo.length ||
        item.visibleOnlyTo.includes(userRole)
      );
    });
  }
}
